"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useButtonSpacing = void 0;
var _useButtonSpacing = require("@cbhq/cds-common/hooks/useButtonSpacing");
var _useInternalSpacingStyles = require("./internal/useInternalSpacingStyles");
const useButtonSpacing = params => {
  const spacing = (0, _useButtonSpacing.useButtonSpacing)(params);
  return (0, _useInternalSpacingStyles.useInternalSpacingStyles)(spacing);
};
exports.useButtonSpacing = useButtonSpacing;